import React, { Component } from 'react';
import { Resizable, ResizableBox } from 'react-resizable';
import Cookies from 'js-cookie';
import jsonFormat from 'json-format';
import fhirpath from 'fhirpath';
import { createComponentMapping } from '../../utils';
import './Debug.scss';

export default class Debug extends Component {
	static defaultProps = {
		client: null
	}

	state = {
		isMinimized: false,
		isValidPath: false,
		isInspecting: false,
		result: '',
		searchPath: '',
		output: [],
		formMapping: null,
		hoverTarget: null,
		hoverTargetBox: null,
		settings: null
	};

	componentDidMount() {
		let $this = this;
		this.setState({ settings: JSON.parse(Cookies.get('debugger') || '{}') });
		
		(function () {
			let target;
			let scrolled = false;

			window.onmousemove = function (e) {
				target = e.target;
			};

			setInterval(function () {
				if ($this.state.isInspecting === false || !target.closest('#form-container')) return;

				let component = target.closest('[ref=component].formio-component');

				if (component !== $this.state.hoverTarget) {
					let elementPosition = component?.getBoundingClientRect();

					$this.setState({
						hoverTarget: component,
						hoverTargetBox: component? {
							width: elementPosition?.width,
							top: elementPosition?.top,
							left: elementPosition?.left,
							height: elementPosition?.height
						} : null
					});
				}
			}, 200);
		})();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.form !== this.props.form) {
			this.setState({
				formMapping: createComponentMapping(this.props.form) || {}
			});
		}
	}

	updateSearchText = (e) => {
		var $this = this;
		var result = '';
		var searchTerm = e ? e.target?.value : this.state.searchPath;

		this.setState({
			searchPath: searchTerm
		});

		if (searchTerm && searchTerm.length > 0 && $this.props.fhirResolve) {
			try {
				result = $this.props.fhirResolve(searchTerm);

				this.setState({ isValidPath: true });
			} catch (ex) {
				this.setState({ isValidPath: false });
			}

			this.setState({
				result: result
			});
		}
	}

	onResizeStop = (e, data) => {
		var settings = this.state.settings || {};
		settings.size = data.size;
		this.setState({ setting: settings });
		this.stopInspect();
		Cookies.set('debugger', settings);
	}

	toggleMinimize = () => {
		this.setState({
			isMinimized: !this.state.isMinimized
		});
	}

	stopInspect = () => {
		this.setState({
			hoverTarget: null,
			hoverTargetBox: null,
			isInspecting: false
		});
	}

	toggleInspect = () => {
		this.setState({
			hoverTarget: null,
			hoverTargetBox: null,
			isInspecting: !this.state.isInspecting
		});
	}

	getInspectValue = () => {
		var el = this.state.formMapping[this.state.hoverTarget.component.path] ||
			this.state.formMapping[this.state.hoverTarget.component.path.replace(/\[(\d+)]\./, '[]\.')];

		if (el) {
			this.setState({
				hoverTarget: null,
				hoverTargetBox: null,
				searchPath: el || ''
			}, () => this.updateSearchText());
		}
	}

	render() {
		var toggleText = this.state.isMinimized ? 'show' : 'hide';
		var showOverlay = this.state.hoverTarget &&
			(
			this.state.formMapping[this.state.hoverTarget.component.path] !== undefined ||
			this.state.formMapping[this.state.hoverTarget.component.path.replace(/\[(\d+)]\./, '[]\.')] !== undefined
			);

		return (
			<>
				<div className={`inspect__overlay ${showOverlay ? '' : 'd-none'}`} style={this.state.hoverTargetBox}
					onClick={this.getInspectValue}>
					
				</div>
				<ResizableBox className={`debugger debugger-${toggleText}`}
					width={this.state.settings?.size?.width || 300} height={this.state.settings?.size?.height || 200}
					resizeHandles={['nw', 'n', 'w']}
					minConstraints={[300, 100]}
					onResizeStop={this.onResizeStop}>
					{
						<>
							<div className="debugger__header">
								FHIRPath Inspector
										<span className={`debugger__minimize debugger__control ${this.state.isInspecting ? 'text-warning' : ''}`} onClick={this.toggleInspect}>(inspect)</span>
								<span className={`debugger__minimize debugger__control`} onClick={this.toggleMinimize}>({toggleText})</span>
							</div>

							{this.props.client ?
								<div className="debugger__container">
									<input type="text" placeholder="Enter FHIRPath" className={`debugger__input ${this.state.isValidPath ? 'bg-valid' : ''} `} onChange={this.updateSearchText} onClick={this.stopInspect} value={this.state.searchPath} />

									<pre className="debugger__output">
										{jsonFormat(this.state.result, {
											type: 'space',
											size: 2
										})}
									</pre>
								</div>
								:
								<div>Please use the launcher to load data before debugging.</div>}
						</>
					}
				</ResizableBox>
			</>
		);
	}
}
